import { connect } from 'react-redux';

import { KnmKindCodesEnum } from 'APIPackage/DictionariesModule/enums/KnmKindCodesEnum';
import { IKnmErknmFormAct } from 'KnmErknmPackage/MainModule/interfaces/IKnmErknmFormAct';
import { IKnmErknmFormInspector } from 'KnmErknmPackage/MainModule/interfaces/IKnmErknmFormInspector';
import { IKnmErknmOrganizationTemplateSelectOption } from 'KnmErknmPackage/MainModule/interfaces/IKnmErknmOrganizationTemplateSelectOption';
import { IKnmErknmFormExpert } from 'KnmErknmPackage/MainModule/interfaces/IKnmErknmFormExpert';
import { IRequirementsNpaInitValues } from 'KnmPackage/RequirementsNpaModalModule/components/RequirementsNpaModal';
import { ActTypesEnum } from 'KnmErknmPackage/ErknmActsModule/enums';
import { getActBlockId } from 'KnmErknmPackage/MainModule/constants/knmErknmFieldsElementsIds';
import { IKnmFormRef } from 'KnmPackage/MainModule/interfaces/IKnmFormRef';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import { getKnmOnSaveButtonClick, getKnmStatus } from 'KnmPackage/MainModule/selectors/knmSelectors';
import { InspectionResultActionTypeEnum } from 'APIPackage/CatalogsModule/enums/InspectionResultActionTypeEnum';
import { getKnmStartDate } from 'KnmErknmPackage/MainModule/selectors/knmErknmSelectors';

import { ErknmActExtract } from './components/ErknmActExtract/ErknmActExtract';
import { ErknmActGeneral } from './components/ErknmActGeneral/ErknmActGeneral';
import { ErknmActSubject } from './components/ErknmActSubject/ErknmActSubject';
import { ErknmActParticipants } from './components/ErknmActParticipants/ErknmActParticipants';
import { ErknmActEvents } from './components/ErknmActEvents/ErknmActEvents';
import { ErknmActViolations } from './components/ErknmActViolations/ErknmActViolations';
import { ErknmActSignInfo } from './components/ErknmActSignInfo/ErknmActSignInfo';
import { ErknmActAdditional } from './components/ErknmActAdditional/ErknmActAdditional';
import { ErknmActIntroductions } from './components/ErknmActIntroductions/ErknmActIntroductions';
import { ErknmActRemarks } from './components/ErknmActRemarks/ErknmActRemarks';
import { ErknmActGeneralImpossible } from './components/ErknmActGeneralImpossible/ErknmActGeneralImpossible';
import { ErknmActSignButton } from './components/ErknmActSignButton/ErknmActSignButton';
import { IKnmStatus } from '../../../../APIPackage/CatalogsModule/interfaces/IKnmStatus';

interface IErknmPaperlessActContentKnmProps {
  acts: IKnmErknmFormAct[] | undefined;
  id: string;
  index: number;
  inspectorsErknm: IKnmErknmFormInspector[] | undefined;
  isWatchOnly: boolean;
  kindKnmCode: KnmKindCodesEnum | undefined;
  name: string;
  organizationsTemplatesSelectOptions: IKnmErknmOrganizationTemplateSelectOption[] | undefined;
  value: IKnmErknmFormAct;
  isDisabledByComplete: boolean;
  isDisabledByDirty: boolean;
  expertsErknm: IKnmErknmFormExpert[] | undefined;
  addRequirementsNpa: (actFieldName: string, fieldName: string) => void;
  addViolatedMandatory: (initialValue: IRequirementsNpaInitValues, fieldName: string, parentFieldName?: string) => void;
  formRef: IKnmFormRef | undefined;
  // isKnmKindRO: boolean;
  isEnablePrescriptionCheck: boolean;
  isPrescriptionCheck: boolean;
}

interface IErknmPaperlessActContentKnmStoreProps {
  onSaveButtonClick: (() => void) | undefined;
  knmStatus: IKnmStatus | undefined;
  startDateKnm: string | undefined;
}

const ErknmPaperlessActContentKnmWithoutStore = ({
  acts,
  id,
  index,
  inspectorsErknm,
  isWatchOnly,
  kindKnmCode,
  name,
  organizationsTemplatesSelectOptions,
  value,
  isDisabledByComplete,
  isDisabledByDirty,
  expertsErknm,
  addRequirementsNpa,
  addViolatedMandatory,
  formRef,
  onSaveButtonClick,
  knmStatus,
  isEnablePrescriptionCheck,
  isPrescriptionCheck,
  startDateKnm,
}: IErknmPaperlessActContentKnmProps & IErknmPaperlessActContentKnmStoreProps) => {
  const { organizationTemplate, organization, involvedExperts, typeAct } = value;
  const isNewOrganizationTemplate = !!organizationTemplate && !organizationTemplate.value;
  const actOrganizationsTemplatesSelectOptions:
    | IKnmErknmOrganizationTemplateSelectOption[]
    | undefined = organizationsTemplatesSelectOptions
    ?.filter(organizationTemplateSelectOption => {
      const isSelectedOrganizationTemplate =
        organizationTemplateSelectOption.id === organizationTemplate?.id ||
        organizationTemplateSelectOption.id === organization?.listId ||
        organizationTemplateSelectOption.value === organizationTemplate?.value;

      return (
        !(isNewOrganizationTemplate && organizationTemplateSelectOption.id === organization?.listId) &&
        (isSelectedOrganizationTemplate ||
          !organizationTemplateSelectOption.inspectionResults?.find(
            i => i.resultActionType === InspectionResultActionTypeEnum.LIGHT_RED,
          ))
      );
    })
    .map(organizationTemplateSelectOption => ({
      ...organizationTemplateSelectOption,
      isDisabled: acts?.some(
        actsItem =>
          organizationTemplateSelectOption.value &&
          actsItem?.organization?.listId === organizationTemplateSelectOption.id &&
          organization?.listId !== organizationTemplateSelectOption.id,
      ),
    }));

  const isDisabledField =
    isWatchOnly || isDisabledByComplete || !!value.signed || isDisabledByDirty || !!value.document;
  const prefixActBlockId = getActBlockId(value.listId);

  if (!typeAct) return null;

  return (
    <>
      <ErknmActExtract extract={value.document} />
      {typeAct.id === ActTypesEnum.KNM_ACT ? (
        <ErknmActGeneral
          isKnm
          name={name}
          isDisabledField={isDisabledField}
          prefixId={prefixActBlockId}
          startDate={startDateKnm}
          extractVersion={value.extractVersion}
          signActDateTime={value.signActDateTime}
        />
      ) : (
        <ErknmActGeneralImpossible
          isKnm
          name={name}
          isDisabledField={isDisabledField}
          value={value}
          prefixId={prefixActBlockId}
        />
      )}
      {typeAct.id === ActTypesEnum.KNM_ACT_IMPOSSIBLE && kindKnmCode === KnmKindCodesEnum.RO && (
        <ErknmActSubject
          id={id}
          kindKnmCode={kindKnmCode}
          organizationsTemplatesSelectOptions={actOrganizationsTemplatesSelectOptions}
          name={name}
          isDisabledField={isDisabledField}
          value={value}
        />
      )}
      {typeAct.id === ActTypesEnum.KNM_ACT && (
        <>
          <ErknmActSubject
            id={id}
            kindKnmCode={kindKnmCode}
            organizationsTemplatesSelectOptions={actOrganizationsTemplatesSelectOptions}
            name={name}
            isDisabledField={isDisabledField}
            value={value}
          />
          <ErknmActParticipants
            isKnm
            id={id}
            index={index}
            inspectorsErknm={inspectorsErknm}
            isDisabledField={isDisabledField}
            name={name}
            expertsErknm={expertsErknm}
            involvedExperts={involvedExperts}
            formRef={formRef}
          />
          <ErknmActEvents
            id={id}
            name={name}
            isDisabledField={isDisabledField}
            actIndex={index}
            formRef={formRef}
            isPaperless={value.paperless}
            value={value}
            knmStatus={knmStatus}
          />
          <ErknmActViolations
            addRequirementsNpa={addRequirementsNpa}
            addViolatedMandatory={addViolatedMandatory}
            id={id}
            index={index}
            isWatchOnly={isWatchOnly}
            name={name}
            value={value}
            isDisabledField={isDisabledField}
            isDisabledByDirty={isDisabledByDirty}
            formRef={formRef}
            isPaperless={true}
            isEnablePrescriptionCheck={isEnablePrescriptionCheck}
            isPrescriptionCheck={isPrescriptionCheck}
          />
        </>
      )}
      <ErknmActSignInfo
        id={id}
        value={value}
        isDisabledField={isDisabledField}
        name={name}
        inspectors={inspectorsErknm}
        formRef={formRef}
      />
      {value.document && (
        <>
          <ErknmActIntroductions id={id} name={name} formRef={formRef} isDisabledByDirty={isDisabledByDirty} />
          {typeAct.id === ActTypesEnum.KNM_ACT && (
            <>
              <ErknmActRemarks
                id={id}
                name={name}
                formRef={formRef}
                isDisabledByDirty={isDisabledByDirty}
                holdingDateTime={value.holdingDateTime}
              />
              {value.fileInvalidate && <ErknmActAdditional name={name} attachment={value.fileInvalidate} />}
            </>
          )}
        </>
      )}
      <ErknmActSignButton
        value={value}
        formRef={formRef}
        onSaveButtonClick={onSaveButtonClick}
        actIndex={index}
        name={name}
      />
    </>
  );
};

const mapStateToProps = (state: IRootState): IErknmPaperlessActContentKnmStoreProps => ({
  onSaveButtonClick: getKnmOnSaveButtonClick(state),
  knmStatus: getKnmStatus(state),
  startDateKnm: getKnmStartDate(state),
});

export const ErknmPaperlessActContentKnm = connect(mapStateToProps)(ErknmPaperlessActContentKnmWithoutStore);
